//客户折扣率
import { HttpGetDisacountRateList, HttpDeleteDisacountRateOne, HttpDeleteDisacountRateList, HttpExportDisacountRate } from '@/service/account';
import TableList from "@components/templates/tablelist";
import comExcel from '@components/templates/excelalert';
import compUpload from "@components/templates/selectupload";
import { mapGetters } from 'vuex';
import compIndex from "./update";
import compCopyrule from "./copyrule";
import mixin from "../mixin"
export default {
    mixins: [TableList,mixin],
    components: {
        compIndex,
        compCopyrule,
        comExcel,
        compUpload
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            workOrderSearchList: [],
            exportData: [],
        };
    },
    methods: {
        ajaxRequest: HttpGetDisacountRateList,
        interceptRequest(data) {
            data.search.LE_startTime = data.search.effectTime;
            data.search.GE_endTime = data.search.effectTime;
            delete data.search.effectTime;
            this.exportData = data;
            return data
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case "export":
                    this.handleWebfs(HttpExportDisacountRate, this.exportData, { executor: 'request', download: true }).then(res => {
                        this.operate = {
                            title: this.$t('global.common.export', { defaultValue: '导出' }),
                            show: true,
                            width: 560,
                            component: "comExcel",
                            showFooter: false
                        }
                    });
                    break;
                case "add":
                    this.$router.push({
                        name: 'cusdisacountrateUpdate',
                        params: { type: "add"},
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: 'cusdisacountrateUpdate',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case "query":
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 1200,
                        component: "compIndex",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case "delete":
                    this.operate = {
                        show: true,
                        alert: 'warning',
                        params: { id: params },
                        title: this.$t('global.common.delete', { defaultValue: '删除' }),
                        ajaxRequest: HttpDeleteDisacountRateOne,
                        desc:this.$t('fbb.localemanage.confirm_delete', { defaultValue: '删除后不可恢复，是否确认删除？' }),
                        formdata: [
                            {
                                label: this.$t('global.common.notes', { defaultValue: '备注' }),
                                tag: "vTextarea",
                                key: 'remark',
                                span: 24,
                                labelWidth: 60,
                                required: false,
                            }
                        ]
                    }
                    break;
                case "copyrule":
                    this.operate = {
                        title: this.$t('fbb.carrier.extra_copy', { defaultValue: '规则复制' }),
                        show: true,
                        width: 650,
                        component: "compCopyrule",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case "queryBlank":
                    var url = this.$router.resolve({
                        name: "cusdisacountrateUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                // case "batchDel":
                //     this.operate = {
                //         show: true,
                //         alert: "error",
                //         params: {
                //             ids: params
                //         },
                //         title: this.$t('global.common.delete', { defaultValue: '删除' }),
                //         desc:this.$t('fbb.localemanage.confirm_delete', { defaultValue: '删除后不可恢复，是否确认删除？' }),
                //         ajaxRequest: HttpDeleteDisacountRateList
                //     };
                //     break;
                case 'import':
                    this.operate = {
                        show: true,
                        title: "导入数据",
                        showDesc: false,
                        component: "compUpload",
                        name: "excelFile",
                        width:450,
                        showFooter: false,
                        actionurl: process.env.VUE_APP_APIURL_FBB + "/api/v2/customerCarrierDiscount/importItems",
                        formdata: [
                            {
                                label: this.$t('erp.product_channel.type', { defaultValue: '类型' }),
                                tag: "Select",
                                key:'discountType',
                                options:this.getDisacountType,
                                props:{
                                    filterable:true,
                                },
                                labelWidth: 90,
                                span:24,
                            },
                        ],
                        downrul: process.env.VUE_APP_APIURL_FBB + "/api/v2/customerCarrierDiscount/itemTemplate",
                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row;
            return [
                {
                    label: this.$t('global.common.query'),
                    to: {
                        name: "cusdisacountrateUpdate",
                        params: {
                            type: 'query',
                        },
                        query: { id }
                    },
                    show: true
                },
                {
                    label: this.$t('global.common.edit'),
                    params: id,
                    to: {
                        name: "cusdisacountrateUpdate",
                        params: {
                            type: 'edit',
                        },
                        query: { id }
                    },
                    show: true
                },
                {
                    label: this.$t('global.common.delete', { defaultValue: '删除' }),
                    params: id,
                    operate: 'delete',
                    show: true
                },
            ];
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getNextOrgList','getLogiticdProCodeList','getCusproductList','getCountryList', 'getCustomServiceAllList', 'getServiceProductAllList']),
        ToolsData() {
            return [
                {
                    label: this.$t('erp.product.new_add', { defaultValue: '添加' }),
                    operate: "add",
                    theme:"primary",
                },
                {
                    label:  this.$t('fbb.carrier.extra_copy', { defaultValue: '规则复制' }),
                    operate: 'copyrule',
                    theme: "info",
                },
                // {
                //     label: this.$t('fbb.accountmanage.muti_loss_effect', { defaultValue: "批量失效" }),
                //     operate: "batchDel",
                //     theme: "primary",
                //     batch: true,
                //     more: true,
                // },
                {
                    name: this.$t('fbb.inbound_import_data', { defaultValue: '导入数据' }),
                    operate: "import",
                    more: true,
                },
                {
                    label:  this.$t('global.common.export', { defaultValue: '导出' }),
                    operate: "export",
                    theme:"success",
                    more:true,
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('bi.work.task_org_id', { defaultValue: '组织' }),
                    key: 'EQ_organizationId',
                    tag: 'Select',
                    options:this.getNextOrgList,
                    props:{
                        filterable:true
                    },
                    show: true,
                },
                {
                    label:this.$t('erp.channelbase.country',{defaultValue:'国家'}),
                    tag:'Select',
                    key:'EQ_regionCode',
                    options:this.getCountryList.map(item=>{
                        return {
                            value:item.value,
                            label:item.label
                        }
                    }),
                },
                {
                    // label: this.$t('fbb.alloment.carrier_code', { defaultValue: '物流商' }),
                    label: "物流产品",
                    tag: "Select",
                    key: "EQ_groupId",
                    show: true,
                    props: {
                        filterable: true
                    },
                    // options: this.hostGroupList
                    options: this.getCustomServiceAllList,
                },
                {
                    label: this.$t('fbb.alloment.carrier_server', { defaultValue: '物流产品服务' }),
                    key: 'IN_logisticsServiceCode',
                    tag: 'Select',
                    options: this.getServiceProductAllList.map(item=>{
                        return {value: item.attach.code, label: item.label}
                    }),
                    props:{
                        filterable: true,
                        multiple: true,
                    },
                    style: "width:200px",
                    show: true,
                },
                {
                    label: this.$t('erp.product_channel.type', { defaultValue: '类型' }),
                    key: 'EQ_discountType',
                    tag: 'Select',
                    options:this.getDisacountType,
                },
                {
                    label:this.$t('fbb.account.takeeffect',{defaultValue:'生效日期'}),
                    key:'effectTime',
                    tag: "vDatepicker",
                    props: {
                        format: "yyyy-mm-dd",
                        confirm: false,
                    },
                },

            ]
        },
        columns() {
            return [
                // {
                //     type: 'selection',
                //     width: 40,
                //     align: 'center',
                //     formName: 'id'
                // },
                {
                    title: this.$t('global.common.actions', { defaultValue: '操作' }),
                    width: 100,
                    render: this.getOperateNodes
                },
                {
                    title: this.$t('bi.work.task_org_id', { defaultValue: '组织' }),
                    key: 'organizationId',
                    render: (h, { row }) => {
                        return <div>
                            <div>
                                <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{this.findRenderLabel(this.getNextOrgList, row.organizationId)}</a>
                                <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            </div>
                        </div>
                    }
                },
                {
                    title: this.$t('erp.channelbase.country', { defaultValue: '国家' }),
                    key: "regionCode",
                    sortable: true,
                    render: (h, { row }) => {
                        const regionCountry=this.getCountryList.filter(item=>item.value===row.regionCode)[0]
                        return regionCountry?regionCountry.label:'--'
                    }
                },
                {
                    title: this.$t('erp.product_channel.type', { defaultValue: '类型' }),
                    key: 'discountType',
                    minWidth: 200,
                    render: (h, { row }) => this.findRenderLabel(this.getDisacountType, row.discountType),
                },
                {
                    title: this.$t('global.common.project', { defaultValue: '项目' }),
                    key: 'lineId',
                    render: (h, { row }) => {
                        return <div>{this.findRenderLabel(this.getCusproductList, row.lineId) || '--'}</div>
                    }
                },
                {
                    // title: this.$t('fbb.alloment.carrier_code', { defaultValue: '物流商' }),
                    title: "物流产品",
                    key: 'groupName',
                },
                {
                    title: this.$t('fbb.alloment.carrier_server', { defaultValue: '物流商服务' }),
                    minWidth: 140,
                    key: 'logisticsServiceCode',
                },
                {
                    title:  this.$t('fbb.account.cusdisacountrate_weight_min', { defaultValue: '重量区间最小值(lbs)' }),
                    key: 'weightRangeMin',
                    render: (h, { row }) => {
                        return <div>{row.weightRangeMin || '--'}</div>
                    }
                },
                {
                    title:  this.$t('fbb.account.cusdisacountrate_weight_max', { defaultValue: '重量区间最大值(lbs)' }),
                    key: 'weightRangeMax',
                    render: (h, { row }) => {
                        return <div>{row.weightRangeMax || '--'}</div>
                    }
                },
                {
                    title: this.$t('fbb.account.cusdisacountrate_zoneStart', { defaultValue: 'Zone区间最小值' }),
                    key: 'zoneStart',
                    render: (h, { row }) => {
                        return <div>{row.zoneStart || '--'}</div>
                    }
                },
                {
                    title: this.$t('fbb.account.cusdisacountrate_zoneEnd', { defaultValue: 'Zone区间最大值' }),
                    key: 'zoneEnd',
                    render: (h, { row }) => {
                        return <div>{row.zoneEnd || '--'}</div>
                    }
                },
                {
                    title: this.$t('fbb.account.cusdisacountrate_rate', { defaultValue: '折扣率' }),
                    maxWidth: 70,
                    key: 'discount',
                },
                {
                    title:this.$t('fbb.account.takeeffectstart',{defaultValue:'生效开始日期'}),
                    key:'startTime',
                },
                {
                    title:this.$t('fbb.account.takeeffectend',{defaultValue:'生效结束日期'}),
                    key:'endTime',
                },
                {
                    title: this.$t('fbb.adjustment.created_name', { defaultValue: '创建人' }),
                    key: 'createdName',
                },

                {
                    title: this.$t('global.common.createdtime', { defaultValue: '创建时间' }),
                    key: 'createdAt',
                }];
        },
    },
};




